import React from 'react';
import { useNavigate } from 'react-router-dom';

const LogoButton = () => {
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate('/')}
            style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                fontSize: '18px', // Adjust font size
                fontWeight: 'bold', // Optional
                color: 'inherit', // Matches surrounding text color
                display: 'flex',
                alignItems: 'center',
                gap: '10px', // Adds spacing between logo and text
            }}
            aria-label="Go to homepage"
        >
            <img
                src="/images/fintech_forge.png"
                alt="Logo"
                style={{
                    width: '250px', // Adjust width
                    height: '150px',
                }}
            />
        </button>
    );
};

export default LogoButton